import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownTextProps {
  children?: string;
  style?: React.CSSProperties;
}

export const MarkdownText: React.FC<MarkdownTextProps> = ({ children, style }) => {
  if (!children) {
    return null;
  }

  const normalizedMarkdown = children
    .replace(/\\n/g, '\n')
    .replace(/\r\n/g, '\n')
    // Preserve 3+ consecutive newlines as visible extra blank paragraphs.
    .replace(/\n{3,}/g, (match) => {
      const extraBlankParagraphs = '\u00A0\n\n'.repeat(match.length - 2);
      return `\n\n${extraBlankParagraphs}`;
    })
    .replace(/(?<!\n)\n(?!\n)/g, '  \n');

  return (
    <span style={style}>
      <ReactMarkdown
        components={{
          // Open links in new tab
          a: ({ node, ...props }) => (
            <a
              {...props}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1976d2', textDecoration: 'underline' }}
            />
          ),
          // Inline paragraphs to avoid extra spacing
          p: ({ node, ...props }) => <span {...props} style={{ display: 'block', margin: '0 0 0.65em 0' }} />,
        }}
      >
        {normalizedMarkdown}
      </ReactMarkdown>
    </span>
  );
};
